import React from 'react';
import { Card, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import VisaIcon from 'assets/icons/visa.svg';
import { PaymentCardProps } from './types';
import { Authorize } from 'app/atoms';
import { PermissionActions } from 'app/modules/Auth/types';
import { PERMISSIONS_SUBJECTS } from 'app/modules/Auth/constants';

const PaymentCard: React.FC<PaymentCardProps> = ({ data, onEdit }) => {
  const { t, i18n } = useTranslation();
  const { cardHolderName, expiryDate, cardNumber, cardType = 'visa' } = data;
  const isRTL = i18n.language === 'ar';

  return (
    <Card className="w-full max-w-[414px] aspect-[414/244] border border-gray-200 p-2 relative">
      <div className="flex justify-between items-center mb-4 sm:mb-6">
        <h3 className="h4-bold text-blackshade-200">{t('profile.paymentMethods.card.cardInfo')}</h3>
        <Authorize
          requiredPermissions={[
            { action: PermissionActions.EDIT_AGENCY_DETAILS, subject: PERMISSIONS_SUBJECTS.AGENCY },
          ]}
        >
          <Button variant="outlined" color="primary" onClick={onEdit}>
            <span className="h5-semibold">{t('profile.paymentMethods.card.edit')}</span>
          </Button>
        </Authorize>
      </div>

      <div className="grid grid-cols-2 gap-2 sm:gap-4 mb-4 sm:mb-6">
        <div>
          <p className="body-regular text-xs sm:text-sm text-blackshade-200 mb-1">
            {t('profile.paymentMethods.card.cardHolderName')}
          </p>
          <p className="h5-bold text-blackshade-200 truncate">{cardHolderName}</p>
        </div>
        <div>
          <p className="body-regular text-xs sm:text-sm text-blackshade-200 mb-1">
            {t('profile.paymentMethods.card.expiryDate')}
          </p>
          <p className="h5-bold text-blackshade-200">{expiryDate}</p>
        </div>
      </div>

      <div className="mb-8 sm:mb-0">
        <p className="body-regular text-xs sm:text-sm text-blackshade-200 mb-1">
          {t('profile.paymentMethods.card.cardNumber')}
        </p>
        <p className="h5-bold text-blackshade-200">{cardNumber}</p>
      </div>

      <div className={`absolute bottom-2 sm:bottom-2 ${isRTL ? 'left-4 sm:left-6' : 'right-4 sm:right-6'}`}>
        <img src={VisaIcon} alt={cardType} className="w-12 h-12 sm:w-20 sm:h-20" />
      </div>
    </Card>
  );
};

export default PaymentCard;
